<template>
  <side-base>
    <div class="swrap">
      <div class="shead">
        <div class="toolbar" v-if="config.enableAdd && app.permission.op('add_campus')">
          <div style="color: var(--c1)" @click="toAdd()">新增收费类型</div>
        </div>
      </div>

      <div class="smain">
        <div class="slist">
          <template v-for="item in listAll">
            <div
              class="sitem van-hairline--bottom"
              :class="{ disable: item.enabled === 0 }"
              v-if="item.enable == 1"
              :key="item.id"
              @click="clickHandler(item)"
            >
              <div class="l sicon">
                <side-icon-select :checked="ids.includes(item.id)" />
              </div>
              <div class="r">
                <!-- <img class="item-photo" :src="getLogoImageUrl(item)" /> -->
                <div class="item-left">
                  {{ item.name }}&nbsp;
                  <span class="non-enable" v-if="item.enabled === 0">未启用</span>
                </div>
              </div>
            </div>
          </template>
        </div>
        <van-empty
          v-if="listAll.length === 0 && !loading"
          image="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/tips/empty.png"
          description="没有找到课时包~"
          image-size="128"
          style="margin-top: 20vh"
        ></van-empty>
      </div>

      <side-foot
        @cancel="close"
        @confirm="confirm(getRet())"
        :confirmSubText="config.radio ? '' : `(${list.length})`"
      >
        <select-Base
          :show="!config.radio"
          :ids="ids"
          :list="list"
          :isAll="checkAll"
          @clickAllBtn="checkAll = !checkAll"
        />
      </side-foot>
    </div>
  </side-base>
</template>

<script>
import sideMixin from '@x3/js/side/0_mixin/mixin-select.js';

export default {
  name: 'x3-side-campus',
  mixins: [sideMixin],
  data() {
    return {
      pageTitle: '选择收费类型',
      // 是否正在加载数据
      loading: true,

      api: this.$api.getOrderFlagList,
      params: {
        enable: 1,
      },
      // 配置项
      config: {
        // 是否单选功能
        radio: true,
        // 是否必须至少选择一项
        must: false,
        // 是否开启新增能力
        enableAdd: true,
      },
    };
  },
  computed: {
    showToolBar() {
      return !this.config.radio || this.config.enableAdd;
    },
  },
  methods: {
    async render() {
      let ret = await this.api(this.params);
      this.listAll = ret.data;
      this.total = ret.data.length;
      this.loading = false;
    },
    toAdd() {
      this.$router.push(`/sf/set/type/add`);
    },
  },
  created() {
    this.render();

    this.$onBus('add-sf_type-success', this.render);
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
.swrap {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .shead {
    .toolbar {
      padding: calc(var(--gap) * 8) calc(var(--gap) * 16);
      display: flex;
      justify-content: flex-end;
      align-items: center;
      font-size: var(--fs-md);
      line-height: var(--lh-md);
      color: var(--g8);
    }
  }
  .smain {
    flex: 1;
    overflow: auto;
    .slist {
      padding: 0 calc(var(--gap) * 16);
      background: var(--white);
      .sitem {
        display: flex;
        align-items: center;
        padding: calc(var(--gap) * 12) 0;
        .l.sicon {
          margin-right: calc(var(--gap) * 16);
          padding-top: calc(var(--gap) * 2);
        }
        .r {
          flex: 1;
          font-size: var(--fs-md);
          line-height: var(--lh-md);
          display: flex;
          align-items: center;
          background: var(--white);
          .item-photo {
            margin-right: calc(var(--gap) * 8);
            width: calc(var(--w) * 40);
            height: calc(var(--w) * 40);
            border-radius: 50%;
            background-color: var(--g5);
          }
          .item-left {
            display: flex;
            align-items: center;
          }
          .non-enable {
            padding-right: 8px;
            font-size: var(--fs-md);
            color: var(--c4);
            vertical-align: text-bottom;
          }
        }
        &.disable {
          .r {
            .item-photo {
              opacity: 0.6;
            }
            .item-left {
              opacity: 0.6;
            }
          }
        }
      }
    }
  }
}
</style>